// @ts-nocheck
import React from 'react';

import '@/components/reporting/_reporting.scss';
import '@/components/reporting/reporting-global.scss';

import { ReportingProvider } from './ReportingContext';
import { ReportingWrapper } from './ReportingWrapper';

import type { UserInterface } from 'sonata-static-storage/lib/schemas/user/user.schema';
import type { UserRoleInterface } from 'sonata-static-storage/lib/schemas/user/userRole.schema';

type Props = {
  campaignIds: string[];
  initialCurrency: string;
  user: UserInterface;
  userRoles: UserRoleInterface[];
};

function Reporting({ campaignIds, initialCurrency, user, userRoles }: Props) {
  return (
    <ReportingProvider campaignIds={campaignIds} currency={initialCurrency} user={user} userRoles={userRoles}>
      <ReportingWrapper />
    </ReportingProvider>
  );
}

export default Reporting;
